(function () {
  'use strict';

  // ── PayPal / accelerated checkout removal ────────────────────
  var PAYPAL_SELECTORS = [
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-target',
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '.accelerated-checkout-block',
    '[data-shopify="accelerated-checkout-buttons"]',
    '[data-testid="Checkout-button"]'
  ];

  function removeAcceleratedCheckout() {
    if (!document.body.classList.contains('template-product')) return;
    PAYPAL_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // MutationObserver — attrape les éléments injectés dynamiquement
  var paypalObserver = new MutationObserver(removeAcceleratedCheckout);
  paypalObserver.observe(document.documentElement, { childList: true, subtree: true });
  removeAcceleratedCheckout();

  // ── Badge panier avec compte à rebours 10 min ─────────────────
  // Lien vers /cart. À l'expiration, le badge disparaît simplement :
  // le panier n'est jamais vidé (aucun stock n'est réellement réservé).
  var TIMER_MS   = 10 * 60 * 1000;
  var KEY_EXPIRY = 'lf_cart_expiry';
  var KEY_COUNT  = 'lf_cart_count';
  var badgeEl = null, toastEl = null, tickerId = null;

  var BAG_ICON = '<svg class="lf-ct-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';

  function store(k, v) { try { v === undefined ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return parseInt(localStorage.getItem(k) || '0', 10); } catch (e) { return 0; } }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function formatTime(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return Math.floor(s / 60) + ':' + pad(s % 60); }

  function fetchCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count || 0; })
      .catch(function () { return 0; });
  }

  function removeBadge() {
    clearInterval(tickerId); tickerId = null;
    if (badgeEl) { badgeEl.remove(); badgeEl = null; }
  }

  function ensureBadge() {
    if (badgeEl) return badgeEl;
    badgeEl = document.createElement('a');
    badgeEl.id = 'lf-cart-timer';
    badgeEl.href = '/cart';
    badgeEl.setAttribute('aria-label', 'Voir mon panier');
    badgeEl.innerHTML = BAG_ICON + '<span class="lf-ct-label">Panier réservé&nbsp;</span><span class="lf-ct-countdown">10:00</span>';
    document.body.appendChild(badgeEl);
    return badgeEl;
  }

  function tick() {
    var remaining = read(KEY_EXPIRY) - Date.now();
    if (remaining <= 0) { removeBadge(); store(KEY_EXPIRY); return; }
    var el = ensureBadge();
    el.querySelector('.lf-ct-countdown').textContent = formatTime(remaining);
    el.classList.toggle('lf-ct-urgent', remaining < 120000);
  }

  function showToast(msg) {
    if (toastEl) toastEl.remove();
    toastEl = document.createElement('div');
    toastEl.id = 'lf-cart-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.textContent = msg;
    document.body.appendChild(toastEl);
    setTimeout(function () { if (toastEl) { toastEl.remove(); toastEl = null; } }, 4000);
  }

  function refresh(isInit) {
    fetchCartCount().then(function (count) {
      if (count === 0 || document.body.classList.contains('template-cart')) {
        removeBadge();
        if (count === 0) { store(KEY_EXPIRY); store(KEY_COUNT); }
        return;
      }
      var prev = read(KEY_COUNT);
      store(KEY_COUNT, count);
      // Nouveau délai de 10 min à chaque article ajouté
      if (!isInit && count > prev) {
        store(KEY_EXPIRY, Date.now() + TIMER_MS);
        showToast('Article ajouté — panier réservé 10 min');
      }
      if (read(KEY_EXPIRY) > Date.now() && !tickerId) {
        tick();
        tickerId = setInterval(tick, 1000);
      }
    });
  }

  // ── Intercepte les ajouts panier (fetch) ─────────────────────
  var _origFetch = window.fetch;
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var p    = _origFetch.apply(this, args);
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { setTimeout(function () { refresh(false); }, 400); });
    }
    return p;
  };

  // ── Intercepte les ajouts panier (XMLHttpRequest) ────────────
  var _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/(add|change|update)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(function () { refresh(false); }, 400); });
    }
    return _origOpen.apply(this, arguments);
  };

  // ── Écoute les clics "Ajouter au panier" ─────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], [data-action="add-to-cart"], [type="submit"]');
    if (btn) setTimeout(function () { refresh(false); }, 800);
  }, true);

  // ── Init ─────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    removeAcceleratedCheckout();
    refresh(true);
  });

})();
